import { Box, Typography, useMediaQuery } from "@mui/material";
import CustomFilterTabs from "../../../Components/CustomFilterTabs";
import CommunityHeaderStyles from "../styles/styles";
import LinearProgressBar from "../../../Components/LinearProgressBar";
import CustomTooltip from "../../../Components/CustomTooltip";
import { useTranslation } from "react-i18next";

const CommunityHeader = (props) => {
  const { activeTab, setActiveTab, communityMemberStats } = props;
  const isMobile = useMediaQuery("(max-width:768px)");

  const { t } = useTranslation("page-manage-communities");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const {
    activeMembersStat,
    joinRequestsStat,
    waitApprovalStat,
    currentMembersStat,
    maxMembersStat,
  } = communityMemberStats || {};

  return (
    <Box sx={CommunityHeaderStyles.container}>
      <CustomFilterTabs
        tabs={[
          {
            label: t("table_tabs.active"),
            count: activeMembersStat,
            value: 1,
          },
          {
            label: t("table_tabs.join_requests"),
            count: joinRequestsStat,
            value: 2,
          },
          {
            label: t("table_tabs.waiting_approval"),
            count: waitApprovalStat,
            value: 3,
          },
        ]}
        activeTab={activeTab}
        onChange={handleTabChange}
      />
      <Box sx={{ width: isMobile ? "100%" : "281px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <img src="/icons/users-gray.svg" alt="users" />
            <Typography
              sx={{
                color: "rgba(47, 43, 61, 0.7)",
                fontSize: "15px",
                fontWeight: 400,
                lineHeight: "20px",
                paddingLeft: "6px",
              }}
            >
              {t("members_of_max", {
                current: (Number(currentMembersStat) || 0).toLocaleString("en-US"),
                max: (Number(maxMembersStat) || 0).toLocaleString("en-US"),
              })}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CustomTooltip
              title={t("max_num_of_members")}
              tooltipSxStyles={{ paddingY: "5px" }}
            >
              <img src="/icons/help-filled-icon.svg" alt="help" />
            </CustomTooltip>
          </Box>
        </Box>

        <Box sx={{ width: "100%", marginTop: "10px" }}>
          <LinearProgressBar
            percentage={Math.round((currentMembersStat / maxMembersStat) * 100)}
            showPercentageText={false}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CommunityHeader;
